import { TopToolbar, FilterButton, CreateButton, ExportButton, useListContext } from 'react-admin';
import { ReactElement } from 'react';

interface MergedListActionsProps {
  customActions?: ReactElement[];
  hasCreate?: boolean;
  hasFilters?: boolean;
}

export default function ExtendedListActions({
  customActions = [],
  hasCreate,
  hasFilters,
}: MergedListActionsProps) {
  const { exporter } = useListContext();
  return (
    <TopToolbar>
      {hasFilters && <FilterButton />}
      {hasCreate && <CreateButton />}
      {exporter !== false && <ExportButton />}
      {...customActions}
    </TopToolbar>
  );
}
